// extracted by mini-css-extract-plugin
export default {"chain":"AddChain_chain__EPXXG","title":"AddChain_title__JCTPi","subtitle":"AddChain_subtitle__7wMC8"};